(ns basic-components.avatar
  (:require
   [frontend.utils :as fu]
   [clojure.string :as string]))

(defn view
  [{:keys [initials class-name picture-url]}]
  (let [picture-url (fu/only-https-or-relative-img picture-url)]
    [:div
     {:class-name (fu/cs "person-profile__circle"
                         (when-not picture-url
                           "person-profile__circle--initials")
                         (when class-name
                           class-name))}
     (if picture-url
       [:img
        {:alt        initials
         :src        (fu/sanitize-img-url picture-url)
         :class-name "person-profile__image-url"}]

       [:span
        {:class-name "person-profile__image"}
        (if-not (string/blank? initials)
          initials
          [:i.fal.fa-user])])]))
